import { mount } from "svelte";
import MvpApp from "../mvp/MvpApp.svelte";
import "../mvp/tailwind.css";

const root = document.getElementById("svelteWalletIsland");

if (root) {
  root.hidden = false;
  root.setAttribute("data-mounted", "mvp");
  mount(MvpApp, { target: root });
}
